const SessionSalesCutoffEnum = Object.freeze({
    SESSION_START: 'session_start',
    SESSION_END: 'session_end',
    SPECIFIC_TIME: 'specific_time',
});

module.exports = SessionSalesCutoffEnum;
